import { render, staticRenderFns } from "./MapIcon.vue?vue&type=template&id=670cb0ad"
import script from "./MapIcon.vue?vue&type=script&lang=js"
export * from "./MapIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports